import { ReactionType } from "@outschool/animation-resources";
// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import React from "react";

export const LottieReact = React.lazy(
  () => import(/* webpackChunkName: "Lottie" */ "lottie-react"),
);

export const loadLottieAnimation = async (reactionType: ReactionType) => {
  const { loadLottieAnimation } = await import(
    /* webpackChunkName: "lottie-loader" */
    "@outschool/animation-resources/dist-esm/lotties"
  );
  return loadLottieAnimation(reactionType);
};
